import React from 'react';
import { quickQuotes } from '../data/content';
export function QuickQuotes() {
  return <section className="w-full bg-cream py-14" aria-label="Stylist quotes" data-id="element-211" data-mp="pmgz20qwgg3a">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 md:grid-cols-3" data-id="element-212" data-mp="poaarugddqi5">
        {quickQuotes.map(quote => <figure key={quote.name} className="flex h-full flex-col" data-id="element-213" data-mp="ymvmp6rc679y">
            <blockquote className="flex-1 font-display text-lg leading-snug text-espresso" data-id="element-214" data-mp="ykj5ivtek0xy">
              “{quote.text}”
            </blockquote>
            <figcaption className="mt-4 font-sans text-sm text-muted" data-id="element-215" data-mp="5yq0efkmwa80">
              <span className="font-bold text-cocoa" data-id="element-216" data-mp="kmundvqpz7wl">{quote.name}</span> · {quote.role} ·{' '}
              {quote.city}
            </figcaption>
          </figure>)}
      </div>
    </section>;
}